module.exports = __webpack_public_path__ + "assets/images_base/bt-button-facebook.svg?v=69ddbc07";